// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__zsdAx","label":"CategoryService_label__1d-YQ","location":"CategoryService_location__3VRER"};